import { render, staticRenderFns } from "./WithdrawReqTable.vue?vue&type=template&id=455a01b1"
import script from "./WithdrawReqTable.vue?vue&type=script&lang=js"
export * from "./WithdrawReqTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports